import { useState } from "react";
import {
  Box,
  Button,
  Text,
  Flex,
  Image,
  Checkbox,
  FormControl,
  FormLabel,
  VStack,
  IconButton,
  HStack,
} from "@chakra-ui/react";
import { FaIceCream, FaMinus, FaPlus } from "react-icons/fa";
import "./styles.css";
import { CloseIcon } from "@chakra-ui/icons";

const ItemModal = ({
  drawerBackgroundColor,
  drawerBorderRadius,
  drawerCloseButtonBackgroundColor,
  drawerCloseButtonBorderRadius,
  drawerCloseButtonIconColor,
  drawerItemTitleColor,
  drawerItemTitleFontSize,
  drawerItemPriceColor,
  drawerItemPriceFontSize,
  drawerItemDescriptionColor,
  drawerItemDescriptionFontSize,
  drawerSectionTitleColor,
  drawerSectionTitleFontSize,
  drawerSectionDividerColor,
  drawerSectionDividerThickness,
  drawerRequiredIndicatorColor,
  drawerRequiredIndicatorFontSize,
  drawerOptionalIndicatorColor,
  drawerOptionalIndicatorFontSize,
  drawerSoldOutTextColor,
  drawerSoldOutBackgroundColor,
  drawerSoldOutFontSize,
  drawerBottomActionsBorderColor,
  drawerBottomActionsBackgroundColor,
  drawerAddToCartButtonColor,
  drawerDisabledButtonColor,
  drawerAddToCartButtonTextColor,
  drawerAddToCartButtonTextFontSize,
  drawerAddToCartButtonBorderRadius,
  drawerIncrementButtonColor,
  drawerDecrementButtonColor,
  drawerQuantityButtonTextColor,
  drawerQuantityButtonTextFontSize,
  drawerQuantityValueColor,
  drawerQuantityValueFontSize,
  drawerQuantityButtonSize,
}) => {
    const [quantity, setQuantity] = useState(1);

    const increment = () => setQuantity((prev) => prev + 1);
    const decrement = () => setQuantity((prev) => (prev > 0 ? prev - 1 : 0));
  return (
    <Box
      width="100%"
      bg={drawerBackgroundColor}
      p={2}
      border={"2px solid"}
      borderColor="gray.300"
      borderRadius={drawerBorderRadius}
    >
      {/* Ice Cream Item Section */}
      <Flex
        direction={{ base: "column", sm: "column" }}
        align="center"
        justify="space-between"
        mb={1}
      >
        <Box position="relative" width="100%">
        {/* Close Icon */}
        <IconButton
          aria-label="Close"
          icon={<CloseIcon color={drawerCloseButtonIconColor}/>}
          size="xs"
          position="absolute"
          top="8px"
          left="8px"
          borderRadius={drawerCloseButtonBorderRadius}
          backgroundColor={drawerCloseButtonBackgroundColor}
          color="gray.600"
          _hover={{ backgroundColor: "gray.200" }}
        />
        
        {/* Ice Cream Image */}
        <Image
          src="https://picsum.photos/id/1/200/300"
          alt="Chocolate Chip Ice Cream"
          width="100%"
          height={{ base: "200px", sm: "200px" }}
          borderRadius="md"
          mb={1}
        />
      </Box>
        <Box ml={2}>
          <Text
            fontSize="md"
            fontWeight="bold"
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            <FaIceCream size={drawerItemTitleFontSize} color={drawerItemTitleColor} />
            Chocolate chip
          </Text>
          <Text fontSize={drawerItemPriceFontSize} color={drawerItemPriceColor}>
            $4.95
          </Text>
          <Text fontSize={drawerItemDescriptionFontSize} color={drawerItemDescriptionColor} mt={1}>
            Classic vanilla with dark chocolate chips.
          </Text>
        </Box>
      </Flex>

      {/* Size Options (Checkboxes) */}
      <FormControl mb={1}>
        <FormLabel color={drawerSectionTitleColor} fontSize={drawerSectionTitleFontSize}>
          Size <span style={{ color: `${drawerRequiredIndicatorColor}`,fontSize:drawerRequiredIndicatorFontSize }}>*</span>
        </FormLabel>
        <Box borderBottom={`${drawerSectionDividerThickness}px solid ${drawerSectionDividerColor}`}/>
        <VStack align="stretch" spacing={2}>
          <Flex justify="space-between">
            <Text fontSize="sm">Kid's size</Text>
            <Checkbox className="custom-checkbox" size="sm" />
          </Flex>
        </VStack>
      </FormControl>

      {/* Cup or Cone Selection (Checkboxes) */}
      <FormControl mb={1}>
        <FormLabel>
          Cup or Cone <span style={{ color: `${drawerRequiredIndicatorColor}` }}>*</span>
        </FormLabel>
        <Box borderBottom={`${drawerSectionDividerThickness}px solid ${drawerSectionDividerColor}`}/>
        <VStack align="stretch" spacing={2}>
          <Flex justify="space-between">
            <Text fontSize="sm">Waffle cone nachos $4.95</Text>
            <Checkbox className="custom-checkbox" size="sm" />
          </Flex>
        </VStack>
      </FormControl>
      <FormControl mb={2}>
        <FormLabel>
          Cup or Cone <span style={{ color: `${drawerRequiredIndicatorColor}` }}>*</span>
        </FormLabel>
        <Box borderBottom={`${drawerSectionDividerThickness}px solid ${drawerSectionDividerColor}`} marginBottom={"5px"}/>
        <VStack align="stretch" spacing={2}>
          <Flex justify="space-between">
            <Text fontSize="sm">Waffle cone nachos $4.95</Text>
            <Flex align="center" justify="space-between" gap={1}>
              {quantity > 0 && (
                <IconButton
                  borderRadius={"full"}
                  border={"1px solid"}
                  borderColor={"gray.300"}
                  aria-label="Decrease"
                  icon={<FaMinus size={"6px"} />}
                  onClick={decrement}
                  size={"xs"}
                  maxWidth={"6px"}
                />
              )}

              <Text fontSize="xs">{quantity}</Text>
              <IconButton
                aria-label="Increase"
                borderRadius={"full"}
                border={"1px solid"}
                borderColor={"gray.300"}
                icon={<FaPlus size={"6px"} />}
                size={"xs"}
                onClick={increment}
              />
            </Flex>
          </Flex>
        </VStack>
      </FormControl>

      {/* Add to Cart Button */}
      <Box
      width="full"
      p={4}
      bg="gray.50"
      borderRadius="md"
      boxShadow="sm"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <HStack>
        <IconButton
          icon={<FaMinus />}
          aria-label="Decrement"
          onClick={decrement}
          backgroundColor={drawerDecrementButtonColor}
          borderRadius="full"
          size="xs"
        />
        <Text fontSize={drawerQuantityValueFontSize} color={drawerQuantityValueColor}>{quantity}</Text>
        <IconButton
          icon={<FaPlus />}
          aria-label="Increment"
          onClick={increment}
          backgroundColor={drawerIncrementButtonColor}
          borderRadius="full"
          size="xs"
        />
      </HStack>
      <Button
        backgroundColor={quantity === 0?drawerDisabledButtonColor:drawerAddToCartButtonColor}
        disabled={quantity === 0}
        size="md"
        ml={4}
        color={drawerAddToCartButtonTextColor}
        borderRadius={drawerAddToCartButtonBorderRadius}
        fontSize={drawerAddToCartButtonTextFontSize}
        isFullWidth
        variant="solid"
      >
        Add to Cart: ${quantity * 4}
      </Button>
    </Box>
    </Box>
  );
};

export default ItemModal;
